
      // Using window object for theme handling (already set in main module)
      if (window.demoTheme && typeof themeSwitcher !== 'undefined') {
          // Apply theme from URL parameter
          themeSwitcher.switchTheme(window.demoTheme);
      }

      if (window.isDemo) {
          // Hide floating theme switcher in demo iframe
          document.addEventListener('DOMContentLoaded', () => {
              const floatingSwitcher = document.getElementById('floating-theme-switcher');
              if (floatingSwitcher) {
                  floatingSwitcher.style.display = 'none';
              }
          });
      }

        // Listen for theme change messages from parent window (demo page)
        window.addEventListener('message', (event) => {
            if (event.data.type === 'THEME_CHANGE' && typeof themeSwitcher !== 'undefined') {
                themeSwitcher.switchTheme(event.data.theme);

                // Apply custom colors if provided
                if (event.data.customColors) {
                    Object.entries(event.data.customColors).forEach(([colorVar, colorValue]) => {
                        document.documentElement.style.setProperty(colorVar, colorValue);
                    });
                }
            }
        });

      // Notify parent window that iframe is ready
      if (window.parent !== window) {
          window.parent.postMessage({ type: 'IFRAME_READY' }, '*');
      }
  